module.exports = __webpack_public_path__ + "acac891ce70185807b99cb9121633c0b.png";